<template>
  <div class="alert alert-info tag-filter-1">
    <div class="search-section">
      <p>انتخاب تگ</p>
      <b-form-input
          @keydown.enter.prevent="submit"
          v-model="searchWords"
          placeholder="جستجو"
      ></b-form-input>
    </div>
    <div v-for="tag in tags" :key="tag.id">

      <div class="form-check">
        <label class="form-check-label my-2 mr-3" @click="setSelectedTag(tag)" :for="`tag_${tag.id}`">
          {{ tag.name }}
        </label>
      </div>

    </div>
  </div>
</template>


<script>
export default {
  name: "TagUser",
  props: {
    tagType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tags: [],
      searchWords: '',
    }
  },
  methods: {
    async getTags() {
      if (this.tagType) {
        this.$store.commit('Tag/setFilters', {key: 'tag_type', value: this.tagType})
      }
      let data = await this.$store.dispatch('Tag/getTags', {page: 1})
      data = data.data.data;
      this.tags = data.data
    },
    submit() {
      this.$store.commit('Tag/setFilters', {key: 'search', value: this.searchWords})
      if (this.tagType) {
        this.$store.commit('Tag/setFilters', {key: 'tag_type', value: this.tagType})
      }
      this.getTags()
    },
    setSelectedTag(tag) {
      this.$emit('selectedTags', {tags: tag})
    }
  },
  mounted() {
    this.getTags();
  },

}
</script>

<style scoped>
.tag-filter-1 {
  height: 300px !important;
  overflow-y: auto;
}

.search-section {
  position: sticky;
  top: 0;
  background-color: #f0f0f0;
  padding: 10px;
  z-index: 1;
  border-bottom: 1px solid #ccc;
}
</style>
